import i18next from 'i18next';

i18next.addResources('es', 'map', {
  routes: 'Corredores',
  showMap: 'Ver mapa',
  projects: 'Proyectos',
  investmentUsd: 'Inversión (USD)',
  home: 'Inicio',
  maps: 'Mapas',
  loading: 'Cargando'
});

i18next.addResources('en', 'map', {
  routes: 'Corridors',
  showMap: 'View map',
  projects: 'Projects',
  investmentUsd: 'Investment (USD)',
  home: 'Home',
  maps: 'Maps',
  loading: 'Loading'
});

i18next.addResources('pt', 'map', {
  routes: 'Rotas',
  showMap: 'Ver mapa',
  projects: 'Projetos',
  investmentUsd: 'Investimento (USD)',
  home: 'Início',
  maps: 'Mapas',
  loading: 'Carregando'
});
